import { render, staticRenderFns } from "./P2PAutoEndTimeSettingEdit.vue?vue&type=template&id=72dd8383&scoped=true&"
import script from "./P2PAutoEndTimeSettingEdit.vue?vue&type=script&lang=js&"
export * from "./P2PAutoEndTimeSettingEdit.vue?vue&type=script&lang=js&"
import style0 from "./P2PAutoEndTimeSettingEdit.vue?vue&type=style&index=0&id=72dd8383&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd8383",
  null
  
)

export default component.exports